export enum NavigationItem {
  Expertise = "expertise",
  About = "about",
  Blog = "blog",
  Contact = "contact",
}

export enum QualificationEnum {
  Education = "Education",
  ProfessionalQualifications = "ProfessionalQualifications",
  ProfessionalMemberships = "ProfessionalMemberships",
  AdditionalResponsibilities = "AdditionalResponsibilities",
  Hobbies = "Hobbies",
}
